/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const AddRowIcon = /*#__PURE__*/ createSvgIcon(
  'AddRowIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M4.5 11.25V16h11v-4.75h-11zm0 6.25c-.412 0-.766-.147-1.06-.44A1.445 1.445 0 013 16V5c0-.412.147-.766.44-1.06a1.44 1.44 0 011.056-.44h.749c.212 0 .39.071.536.214.146.143.219.32.219.532 0 .21-.072.39-.216.535A.72.72 0 015.25 5H4.5v4.75h11V5h-.746a.736.736 0 01-.535-.214.714.714 0 01-.219-.532c0-.21.072-.39.216-.535a.723.723 0 01.536-.219h.752c.414 0 .767.147 1.059.44.291.294.437.648.437 1.06v11c0 .413-.147.766-.44 1.06-.294.293-.647.44-1.06.44h-11zM9.25 5h-1a.728.728 0 01-.534-.214.72.72 0 01-.216-.532c0-.21.072-.39.216-.535A.72.72 0 018.25 3.5h1v-1c0-.212.071-.39.214-.534a.72.72 0 01.532-.216c.21 0 .39.072.535.216a.72.72 0 01.219.534v1h1c.213 0 .39.071.534.214a.72.72 0 01.216.532c0 .21-.072.39-.216.535A.72.72 0 0111.75 5h-1v1c0 .213-.072.39-.214.534a.72.72 0 01-.532.216.734.734 0 01-.535-.216A.72.72 0 019.25 6V5z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default AddRowIcon;
